(function () {
  // === 1) Анти-дубликат Rebuy ===============================================
  var REBUY = /cdn\.rebuyengine\.com\/onsite\/js\/rebuy\.js/i;
  var loaded = false;

  // учтём уже вставленный тег
  for (var s of document.scripts) {
    if (s.src && REBUY.test(s.src)) { loaded = true; break; }
  }

  function blockScript(node) {
    if (!node || node.tagName !== 'SCRIPT') return false;
    if (!node.src || !REBUY.test(node.src)) return false;
    if (!loaded) { loaded = true; window.__REBUY_LOADED__ = true; return false; }
    // console.warn('[REBUY GUARD] prevented duplicate:', node.src);
    return true;
  }

  ['appendChild', 'insertBefore'].forEach(function (m) {
    var _o = Node.prototype[m];
    Node.prototype[m] = function (n) { if (blockScript(n)) return n; return _o.apply(this, arguments); };
  });

  var d = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
  if (d && d.set) {
    Object.defineProperty(HTMLScriptElement.prototype, 'src', {
      configurable: true,
      get: d.get,
      set: function (v) {
        if (typeof v === 'string' && REBUY.test(v) && loaded) {
          // console.warn('[REBUY GUARD] src setter blocked duplicate:', v);
          v = '';
        }
        return d.set.call(this, v);
      }
    });
  }

  // === 2) Глушилка "мертвых" product JSON ===================================
  // Добавь сюда хендлы, которые не должны запрашиваться (с .json или без)
  var DEAD = [
    /\/products\/sprout-impact-v2(?:\.json)?$/i,
    /\/products\/sprout-impact-plastics-v2(?:\.json)?$/i
  ];

  function isDeadUrl(u) {
    try {
      // поддержим относительные пути и Request объекты
      var url = typeof u === 'string' ? u : (u && u.url);
      if (!url) return false;
      // Если передали относительный путь — нормализуем к абсолютному
      if (url.charAt(0) === '/') url = location.origin + url;
      return DEAD.some(function (re) { return re.test(url); });
    } catch (e) { return false; }
  }

  // Перехват fetch
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      if (isDeadUrl(input)) {
        var u = (typeof input === 'string') ? input : input.url;
        // console.warn('[REBUY GUARD] blocked fetch to dead product JSON:', u);
        return Promise.resolve(new Response('{}', {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      return _fetch.apply(this, arguments);
    };
  }

  // Перехват XMLHttpRequest
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__blockDead__ = isDeadUrl(url);
    if (this.__blockDead__) {
      // console.warn('[REBUY GUARD] blocked XHR open to dead product JSON:', url);
    }
    return _open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this.__blockDead__) {
      var xhr = this;
      // эмулируем успешный ответ 200 с пустым JSON
      setTimeout(function () {
        try {
          Object.defineProperty(xhr, 'readyState', { value: 4 });
          Object.defineProperty(xhr, 'status', { value: 200 });
          Object.defineProperty(xhr, 'responseText', { value: '{}' });
        } catch (e) {
          // Fallback если defineProperty запрещён
          xhr.readyState = 4; xhr.status = 200; xhr.responseText = '{}';
        }
        xhr.onreadystatechange && xhr.onreadystatechange();
        xhr.onload && xhr.onload();
      }, 0);
      return;
    }
    return _send.apply(this, arguments);
  };
})();
